import React from 'react';

function InfoCard({ label, value }) {
  return (
    <article className="table-card stat-card">
      <span className="section-subtitle">{label}</span>
      <strong className="stat-value observability-stat-value">{value}</strong>
    </article>
  );
}

export default function ObservabilityView({ metadata }) {
  const dashboardUrl = metadata?.dashboardUrl || '';
  const metricsPath = metadata?.metricsPath || '/metrics';
  const enabled = Boolean(metadata?.enabled && dashboardUrl);

  if (!enabled) {
    return (
      <section className="monitor-layout">
        <section className="table-card">
          <div className="table-toolbar compact-toolbar mobile-stack-toolbar">
            <div>
              <div className="brand-badge">Observabilidad</div>
              <h2 className="section-title with-margin">Grafana y Prometheus</h2>
            </div>
          </div>
          <p className="error-text">No hay un dashboard de observabilidad configurado para este entorno.</p>
        </section>
      </section>
    );
  }

  return (
    <section className="monitor-layout">
      <div className="monitor-stats-grid technical-stats-grid">
        <InfoCard label="Visualización" value="Grafana" />
        <InfoCard label="Métricas" value="Prometheus" />
        <InfoCard label="Fuente" value="Backend + jobs" />
      </div>

      <section className="table-card observability-card">
        <div className="table-toolbar compact-toolbar mobile-stack-toolbar">
          <div>
            <div className="brand-badge">Observabilidad</div>
            <h2 className="section-title with-margin">Grafana y Prometheus</h2>
            <p className="section-subtitle">Métricas.</p>
          </div>
          <div className="row-action-group">
            <a className="secondary-button" href={dashboardUrl} target="_blank" rel="noreferrer">Abrir Grafana</a>
            <a className="secondary-button" href={metricsPath} target="_blank" rel="noreferrer">Ver /metrics</a>
          </div>
        </div>

        <div className="observability-frame-shell">
          <iframe
            title="Grafana Dashboard"
            src={dashboardUrl}
            className="observability-frame"
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
      </section>
    </section>
  );
}
